module.exports = __webpack_public_path__ + "img/img-5.b085a2d0.svg";